import { Box, Flex, Grid, GridItem, Image, Input, Text, Drawer, DrawerOverlay, DrawerContent, DrawerCloseButton, DrawerHeader, DrawerBody, FormControl, FormLabel, Button, Center, Spinner, Tooltip, IconButton, } from '@chakra-ui/react'
import MyDiv from './department.style';
import { AddIcon, EditIcon } from '@chakra-ui/icons';
import { CustomButton, CustomToast } from '../../../../components';
import { useEffect, useState } from 'react';
import PlusIcon from "../../../../assets/images/Vector.svg";
import { IDepartment } from './model';
import { useFetch } from '../../../../hooks/useFetch';
import CustomTables, { Column, ILazyParams } from "../../../../components/CustomTable/CustomTables";
import Designation from './Designation';



const MasterDepartment = () => {
    const [departments, setDepartments] = useState<IDepartment[]>([]);
    const [DrawerOpen, setDrawerOpen] = useState(false);
    const [selectedId, setSelectedId] = useState<number | null>(null);
    const [isEditMode, setIsEditMode] = useState(false);
    const [currentDepartment, setCurrentDepartment] = useState({ id: 0, departmentName: '', });
    const { addToast } = CustomToast();
    const { fetchApi } = useFetch(addToast);
    const [selectedDepartment, setSelectedDepartment] = useState<IDepartment | null>(null);
    const [designationDrawerOpen, setDesignationDrawerOpen] = useState(false);

    const [dataLoading, setDataLoading] = useState(false);
    const [totalCount, setTotalCount] = useState(0);
    const [lazyParams, setLazyParams] = useState<ILazyParams>({
        first: 0, rows: 20, sortField: undefined, sortOrder: undefined,
        multiSortMeta: [], filters: {}, globalFilter: '',
    });

    useEffect(() => {
        loadDepartment();
    }, [lazyParams]);

    const loadDepartment = async () => {
        setDataLoading(true);
        const params = new URLSearchParams();
        params.set('first', String(lazyParams.first));
        params.set('rows', String(lazyParams.rows));
        if (lazyParams.sortField) params.set('sortField', lazyParams.sortField);
        if (lazyParams.sortOrder) params.set('sortOrder', String(lazyParams.sortOrder));
        if (lazyParams.globalFilter) params.set('globalFilter', lazyParams.globalFilter);
        if (lazyParams.filters && Object.keys(lazyParams.filters).length) {
            params.set('filters', JSON.stringify(lazyParams.filters));
        }

        const response = await fetchApi<any>(`Hrlense_Department?${params.toString()}`, "GET");
        if (response) {
            setDepartments(response.data ?? response ?? []);
            setTotalCount(response.totalRecords ?? response.length ?? 0);
        }
        setDataLoading(false);
    };


    const handleAddDepartment = () => {
        setIsEditMode(false);
        setCurrentDepartment({ id: 0, departmentName: '' });
        setDrawerOpen(true);
    };

    const handleEditDepartment = (departmentName: IDepartment) => {
        setIsEditMode(true);
        setSelectedId(departmentName.id);
        setCurrentDepartment(departmentName);
        setDrawerOpen(true);
    };

    const handleInputChange = (e: any) => {
        const { name, value } = e.target;
        if (!/^[A-Za-z\s]*$/.test(value)) {
            return;
        }
        setCurrentDepartment(prev => ({
            ...prev,
            [name]: value
        }));
    };


    const handleSubmit = async () => {
        if (!currentDepartment.departmentName.trim()) {
            addToast({ message: "Please enter Department Name", status: "warning" });
            return;
        }
        if (isEditMode) {
            const response = await fetchApi(`Hrlense_Department/${currentDepartment.id}`, "PUT", { id: currentDepartment.id, departmentName: currentDepartment.departmentName, }, null, "Department updated successfully");

            if (response) await loadDepartment();

        } else {
            const response = await fetchApi<IDepartment>("Hrlense_Department", "POST", { departmentName: currentDepartment.departmentName, }, null, "Department added successfully");
            if (response) await loadDepartment();
        }
        setDrawerOpen(false);
    };

    const handleAddDesignation = (row: IDepartment) => {
        setSelectedDepartment(row);
        setDesignationDrawerOpen(true);
    };


    return (
        <MyDiv>
            <Box position="relative" minH="300px">
                <>
                    <Flex className="page_heading flex_header" >
                        <Text className="font-poppins text_semibold text_3xl">Department </Text>
                        <Flex gap={2}>
                            <CustomButton title="Add New Department" className=' btn font-poppins text_sm text_medium' rightIcon={<Image src={PlusIcon} className='logo' />} onClick={handleAddDepartment} />
                        </Flex>
                    </Flex>
                    <Grid className='grid_container'>
                        <GridItem colSpan={12}>
                            <CustomTables<IDepartment>
                                value={departments} loading={dataLoading} emptyMessage="No departments found." preferenceKey="departmentTable"
                                showGlobalSearch={false} showToolbar={true} lazy lazyParams={lazyParams} onLazyParamsChange={setLazyParams} totalRecords={totalCount}
                                showPagination rowsPerPageOptions={[20, 100, 200, 500]} maxTableHeight={null}
                            >
                                <Column header="S. No" body={(_, index) => lazyParams.first + index + 1} />
                                <Column header="Department Name" field='departmentName' sortable filterable filterType="text" />
                                <Column header="Actions" frozen="right" body={(row: any) => (
                                        <Flex align="center" gap={1}>
                                            <Tooltip label="Edit Department" hasArrow>
                                                <IconButton aria-label="Edit" icon={<EditIcon />} size="sm" colorScheme="orange" variant="ghost" onClick={() => handleEditDepartment(row)} />
                                            </Tooltip>
                                            <Tooltip label="Add Designation" hasArrow>
                                                <IconButton aria-label="Add Designation" icon={<AddIcon />} size="sm" colorScheme="green" variant="ghost" onClick={() => handleAddDesignation(row)} />
                                            </Tooltip>
                                        </Flex>
                                    )}
                                />
                            </CustomTables>
                        </GridItem>
                    </Grid>

                    <Drawer isOpen={DrawerOpen} placement="right" onClose={() => setDrawerOpen(false)} size="sm">
                        <DrawerOverlay />
                        <DrawerContent>
                            <DrawerCloseButton />
                            <DrawerHeader borderBottomWidth="1px">{isEditMode ? 'Edit Department' : 'Add New Department'}</DrawerHeader>
                            <DrawerBody display="flex" flexDirection="column" justifyContent="space-between" height="100%">
                                <Box py={4}>
                                    <FormControl mb={4} isRequired>
                                        <FormLabel >Department Name</FormLabel>
                                        <Input name="departmentName" value={currentDepartment.departmentName} onChange={handleInputChange} placeholder="Enter department name" />
                                    </FormControl>
                                </Box>
                                <Flex justify="flex-end" mt={4} gap={2}>
                                    <Button className="font-poppins text_sm text_medium" onClick={() => setDrawerOpen(false)} style={{ backgroundColor: '#D92F34', color: 'white' }}>Cancel</Button>
                                    <Button onClick={handleSubmit} className="font-poppins text_sm text_medium" style={{ backgroundColor: '#006838', color: 'white' }}>{isEditMode ? "Update Department" : "Add Department"}</Button>
                                </Flex>
                            </DrawerBody>
                        </DrawerContent>
                    </Drawer>
                </>
            </Box>
            <Designation isOpen={designationDrawerOpen} onClose={() => setDesignationDrawerOpen(false)} department={selectedDepartment} />
        </MyDiv>
    )
}

export default MasterDepartment;